module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-recurring-task-checklists-5072360af7aa7f155ccee5f8f0fad56f.png";